import reactStringReplace from "react-string-replace";
import { useAppContext } from "../../_context";

const BrowseToChooseFile = ({ onClick }) => {
  const [{ tx }] = useAppContext();

  return (
    <p className="mb-0">
      {reactStringReplace(
        tx["or [browse] to choose a file"],
        "[browse]",
        (_, index) => {
          return (
            <span
              key={index}
              className="text-primary fw-bold cursor-pointer"
              onClick={onClick}>
              {tx["browse"]}
            </span>
          );
        },
      )}
    </p>
  );
};

export default BrowseToChooseFile;
